/*
 * @Author: niuqingxia
 * @Date: 2024-12-19 18:15:55
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-12-Mo 03:50:44
 独立数字
 */

<template>
  <div :key="uniqueKey" class="independent-number">
    <div
      class="independent-number-chart-title"
      :style="titleBarInlineStyle">
      {{ config.chartTitle }}
      <el-tooltip v-if="config.chartViewData.showIndicator" class="item" :open-delay="500" effect="dark" placement="top">
        <div slot="content" v-html="indicatorDescription"></div>
        <i class="el-icon-question"></i>
      </el-tooltip>
    </div>
    <div class="independent-number-container">
      <span
        v-for="(number,i) in curNumber"
        :key="i"
        class="number-item"
        :style="{
          fontSize: config.chartSet.chartStyle.fontSize + 'px',
          color: config.chartSet.chartStyle.color
        }">
        <div>
          <span class="number-item-text"> {{ number }}</span>
          <NumberBorderTemp class="number-bg" :border-color="borderColor" :number-border-type="numberBorderType"></NumberBorderTemp>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import NumberBorderTemp from './numberBorderTemp.vue'
import { COLOR_LIST } from '@/utils/defaultColorData'
import ChartMixin from '../mixin'
export default {
  name: 'IndependentNumber',
  components: {
    NumberBorderTemp,
  },
  mixins: [ChartMixin],
  props: {
    config: {
      type: Object,
    },
    componentType: {
      type: String,
    },
    globalConfig: {
      type: Object,
    },
  },
  data () {
    return {
      uniqueKey: 'xxx',
    }
  },
  computed: {
    // 表格数据
    chartData () {
      return this.config.chartViewData.chartData
    },
    curNumber () {
      if (!this.chartData?.length) return
      // 除第一列(维度)之外的所有表头key集合 keyList
      const colKeyList = Object.keys(this.chartData[0])
      // 表格数据 (去除第一行(表头))
      const tableData = this.chartData.slice(1)
      return (tableData[0][colKeyList[0]] + '').split('') // 第一个单元格数据
    },
    borderColor () {
      return this.config.chartSet.borderStyle.color
    },
    numberBorderType () {
      return this.config.chartSet.borderStyle.numberBorderType
    },
  },
  watch: {
    resolvedChartColorsLabel () {
      this.config.chartSet.borderStyle.color = COLOR_LIST.filter(item => { return item.label === this.resolvedChartColorsLabel })[0].value[0]
    },
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.uniqueKey = Math.random()
      this.config.chartSet.borderStyle.color = COLOR_LIST.filter(item => { return item.label === this.resolvedChartColorsLabel })[0].value[0]
    },

  },

}
</script>

<style lang="scss" scoped>
.independent-number{
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: visible;
  &-chart-title {
    padding: 0 10px;
  }
  .independent-number-container{
    flex: 1;
    display: flex;
    align-items: center;
    height: 100%;
    .number-item{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin: 0 10px;
      font-family: digital-mono-italic;
      font-weight: 800;
      position: relative;
      .number-item-text{
        // position: absolute;
        cursor: default;
      }
      .number-bg{
        position: absolute;
        height: 100%;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

</style>
